import useContentful from '../api/useContentful';

export default function useClients() {
    const { data, isLoading } = useContentful('o6mivagQGhx5YoPrbV0m5');

    const title = data?.title || '';
    const update = data?.update || '';
    const intro = data?.intro || '';
    const desc = data?.desc || '';
    const terms = data?.terms || '';

    return {
        title,
        update,
        intro,
        desc,
        terms,
        isLoading
    };
}
